import React, { useState, useEffect } from 'react';
import TR from '../../Trans';
import StrService from './../../services/str';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

function TermsDialog(props) {

  const [termsHtml, setTermsHtml] = useState("");

  const getTerms = () => { 
    StrService.get(props.url, {})
      .then(function (res) {
        setTermsHtml(res.data);
      });
  };

  useEffect(() => { 
    if (props.url) {
      getTerms();
    }
  }, []);

  useEffect(() => { 
    if (props.url) {
      getTerms();
    }
  }, [props.url]);

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onClose();
    }
  };

  return (
    <BDialog disableRestoreFocus className="muvika-terms-dialog" fullScreen={true} open={props.open} onClose={props.onClose}>
      <DialogTitle>{props.title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={props.onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <div dangerouslySetInnerHTML={{ __html: termsHtml }}>

        </div>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="success" onClick={props.onClose}>{TR.cm_close}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default TermsDialog;